(function($) {

	'use strict';

	var init = function() {
		setupFilterListeners();
		setupChunkVisibility();

		revealChunk();
		revealFilters();
	};

	var setupFilterListeners = function() {
		$('.filter-item').on('click', function() {
			// Uncheck all (disable multi-select)
			$(this).parent().children().not(this).each(function() {
				$(this).find('input').prop("checked", false);
			});
			// ---

			var $checkbox = $(this).find('input');
			$checkbox.prop("checked", !$checkbox.prop("checked"));

			$(this).parents('form:first').submit();
		});
	}

	var setupChunkVisibility = function() {
		$('.makings__list__chunk:first').addClass('active');

		if ($('.makings__list__chunk:not(".active")').length == 0) {
			$('.makings__more').hide();
		}
	}

	var revealChunk = function() {
		$('.makings__more').on('click', function() {
			var $firstHiddenChunk = $('.makings__list__chunk:not(".active"):first');
			$firstHiddenChunk.addClass('active');

			if ($('.makings__list__chunk:not(".active")').length == 0) {
				$(this).hide();
			}
		});
	}

	var revealFilters = function() {
		$('.makings__search__placeholder').on('click', function() {
			$(this).parent().toggleClass('active');
		});
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
